const key = "tl-credentials";
export default class ApplicationCredentials {
    saveCredentials (auth, username){
        window.localStorage.setItem(key, JSON.stringify({token: auth, user: username }));
    }
    loadCredentials() {
        return JSON.parse(window.localStorage.getItem(key));
    }
    getLoggedInUser() {
        let credentials = this.loadCredentials();
        if (credentials) {
            return credentials.user;
        }  else {
            return null;
        }
    }
    isLoggedIn() {
        return this.getLoggedInUser() != null;
    }
    clearLoggedInUser() {
        window.localStorage.removeItem(key);
    }

    signOutIfExpired(){
        if (this.isLoggedIn()){
            if (this.isLoginExpired()) {
               this.clearLoggedInUser();
            }
        }
    }

    isLoginExpired() {
        const creds = this.loadCredentials();
        const jwtString = creds.token.split('Bearer ')[1];
        const jwt = this.parseJwt(jwtString)
        return Date.now() >= jwt.exp * 1000;
    }

    parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }
}
